module.exports = __webpack_public_path__ + "img/alibaba-logo.530ec267.svg";